export const GET_IQROGURU_SUCCEED = "iqroguru/get/succeed";
export const GET_IQROGURU_REQUEST = "iqroguru/get/request";
export const GET_IQROGURU_FAILED = "iqroguru/get/failed";

export const GET_IQROGURUAWAL_SUCCEED = "iqroguru/getawal/succeed";
export const GET_IQROGURUAWAL_REQUEST = "iqroguru/getawal/request";
export const GET_IQROGURUAWAL_FAILED = "iqroguru/getawal/failed";

export const CREATE_IQROGURU_REQUEST = "iqroguru/create/request";
export const CREATE_IQROGURU_SUCCEED = "iqroguru/create/succeed";
export const CREATE_IQROGURU_FAILED = "iqroguru/create/failed";

export const DELETE_IQROGURU_REQUEST = "iqroguru/delete/request";
export const DELETE_IQROGURU_SUCCEED = "iqroguru/delete/succeed";
export const DELETE_IQROGURU_FAILED = "iqroguru/delete/failed";

export const GET_BY_ID_IQROGURU_REQUEST = "iqroguru/getid/request";
export const GET_BY_ID_IQROGURU_SUCCEED = "iqroguru/getid/succeed";
export const GET_BY_ID_IQROGURU_FAILED = "iqroguru/getid/failed";

export const GET_BY_RUMAHTAHFIDZ_IQROGURU_REQUEST =
  "iqroguru/getrumahtahfidz/request";
export const GET_BY_RUMAHTAHFIDZ_IQROGURU_SUCCEED =
  "iqroguru/getrumahtahfidz/succeed";
export const GET_BY_RUMAHTAHFIDZ_IQROGURU_FAILED =
  "iqroguru/getrumahtahfidz/failed";

export const GET_BY_MASTERTAHFIDZ_IQROGURU_REQUEST =
  "iqroguru/getbymastertahfidz/request";
export const GET_BY_MASTERTAHFIDZ_IQROGURU_SUCCEED =
  "iqroguru/getbymastertahfidz/succeed";
export const GET_BY_MASTERTAHFIDZ_IQROGURU_FAILED =
  "iqroguru/getbymastertahfidz/failed";

export const UPDATE_IQROGURU_REQUEST = "iqroguru/update/request";
export const UPDATE_IQROGURU_SUCCEED = "iqroguru/update/succeed";
export const UPDATE_IQROGURU_FAILED = "iqroguru/update/failed";
